module.exports = __webpack_public_path__ + "media/images/icons/filled/dingtalk-circle-c2ad72cae7668cb11e12f973db67fe63.svg";